import React, { FC, useContext } from "react";
import { Chip, Paper, Typography } from "@material-ui/core";
import { makeStyles, Theme } from "@material-ui/core/styles";
import { Close } from "@material-ui/icons";
import { FiltersContext } from "../../context";
import { remove } from "lodash";
import { validate } from "../../functions";

const useStyles = makeStyles((theme: Theme) => ({
  container: {
    minHeight: "32px",
    backgroundColor: theme.palette.background.default,
    padding: 8,
  },
  chip: {
    backgroundColor: "white",
    color: "#003368",
    borderRadius: 4,
    marginRight: 8,
    marginBottom: 4,
  },
  chipIcon: {
    color: "#003368",
    width: 12,
    height: 12,
  },
  noFilters: {
    height: "32px",
    marginLeft: "0.5rem",
    display: "flex",
    alignItems: "center",
  },
}));

const ChipsContainer: FC = () => {
  const classes = useStyles();

  const [filtersContext, setFiltersContext] = useContext(FiltersContext);

  const filtersApplied = !validate.allObjectValuesEmpty(filtersContext);

  const handleDelete = (section, filter) => {
    const remainingFilters = remove(filtersContext[section], (value) => value !== filter);

    setFiltersContext({
      ...filtersContext,
      [section]: remainingFilters,
    });
  };

  return (
    <Paper className={classes.container} elevation={2}>
      {filtersApplied ? (
        Object.keys(filtersContext).map((filterSection) => {
          return filtersContext[filterSection].map((filter) => (
            <Chip
              key={filter}
              className={classes.chip}
              size="small"
              label={filter}
              deleteIcon={<Close className={classes.chipIcon} />}
              onDelete={() => handleDelete(filterSection, filter)}
            />
          ));
        })
      ) : (
        <div className={classes.noFilters}>
          <Typography variant="body2">No filters applied</Typography>
        </div>
      )}
    </Paper>
  );
};

export default ChipsContainer;
